/**
 * @generated SignedSource<<907e4fea993562414a0211669e4610ee>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ColumnConfigWithContainer_savedViewId$data = {
  readonly savedViewId?: string | null | undefined;
  readonly " $fragmentType": "ColumnConfigWithContainer_savedViewId";
};
export type ColumnConfigWithContainer_savedViewId$key = {
  readonly " $data"?: ColumnConfigWithContainer_savedViewId$data;
  readonly " $fragmentSpreads": FragmentRefs<"ColumnConfigWithContainer_savedViewId">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewtechnicalchangesenabledrelayprovider"
    }
  ],
  "kind": "Fragment",
  "name": "ColumnConfigWithContainer_savedViewId",
  "selections": [
    {
      "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewtechnicalchangesenabledrelayprovider",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "savedViewId"
        }
      ]
    }
  ],
  "type": "JiraIssueSearchViewMetadata",
  "abstractKey": "__isJiraIssueSearchViewMetadata"
};

(node as any).hash = "afbf244a6fb59419cd38207a8d27060a";

export default node;
